import {
  LOCAL_STORAGE_AUTHORIZED_KEY,
  LOCAL_STORAGE_AUTHORIZED_REFRESH_KEY,
  LOCAL_STORAGE_AUTHORIZED_SESSION_KEY,
  LOCAL_STORAGE_AUTHORIZED_SESSION_TIMEOUT,
} from '../../configs/names';

export const getStoredAccessToken = () => {
  try {
    return window.localStorage.getItem(LOCAL_STORAGE_AUTHORIZED_SESSION_KEY) || null;
  } catch (e) {
    return null;
  }
};

export const getStoredRefreshToken = () => {
  try {
    return window.localStorage.getItem(LOCAL_STORAGE_AUTHORIZED_REFRESH_KEY) || null;
  } catch (e) {
    return null;
  }
};

export const setStoredAccessToken = token => {
  window.localStorage.setItem(LOCAL_STORAGE_AUTHORIZED_SESSION_KEY, token);
};

export const setStoredRefreshToken = token => {
  if (token) {
    window.localStorage.setItem(LOCAL_STORAGE_AUTHORIZED_REFRESH_KEY, token);
  } else {
    window.localStorage.removeItem(LOCAL_STORAGE_AUTHORIZED_REFRESH_KEY);
  }
};

export const clearStoredAuth = () => {
  window.localStorage.removeItem(LOCAL_STORAGE_AUTHORIZED_SESSION_KEY);
  window.localStorage.removeItem(LOCAL_STORAGE_AUTHORIZED_REFRESH_KEY);
  window.localStorage.removeItem(LOCAL_STORAGE_AUTHORIZED_KEY);
  window.localStorage.removeItem(LOCAL_STORAGE_AUTHORIZED_SESSION_TIMEOUT);
};

export const buildLogoutPayload = refresh => (refresh ? { refresh } : {});
